// extracted by mini-css-extract-plugin
var _1 = "clear-signature__xAbEx";
var _2 = "pen__P2GGa";
var _3 = "signature__KAsZx";
var _4 = "signature-label__N_XXJ";
export { _1 as "clear-signature", _2 as "pen", _3 as "signature", _4 as "signature-label" }
